import styles from "./SettingsPage.module.scss";

import { useDispatch, useSelector } from "react-redux";

import { ChangeEvent } from "react";
import FloatingButton from "../Shared/FloatingButton/FloatingButton";
import { GlobalState } from "../../redux/store";
import { SettingsTypes } from "../../redux/reducers/SettingsReducer";
import { strings } from "../../util/language";
import { Link, useNavigate } from "react-router-dom";
import { FcUndo } from "react-icons/fc";

const BritishFlag = "images/BritishFlag.png";
const CroatianFlag = "images/CroatianFlag.png";
const GermanFlag = "images/GermanFlag.png";
const IMAGE = "/images/memory5.png";

const SettingsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = useSelector((state: GlobalState) => state.settings);
  const locationCount = useSelector(
    (state: GlobalState) => state.actions.locationCount
  );

  const style = {
    backgroundImage: `url(${IMAGE})`,
    backgroundSize: "cover",
  };

  const flagClicked = (country: string) => {
    if (country !== language) {
      dispatch({ type: SettingsTypes.Language, payload: country });
    }
  };

  return (
    <div style={style} className={styles.settings}>
      <div className={styles.flex}>
        <div
          className={`${styles.item} ${language !== "hr" ? {} : styles.active}`}
          onClick={() => flagClicked("hr")}
        >
          <img src={CroatianFlag} alt={strings[language].settingsPage.hr} />
          <h2>{strings[language].settingsPage.hr}</h2>
        </div>
        <div
          className={`${styles.item} ${language !== "en" ? {} : styles.active}`}
          onClick={() => flagClicked("en")}
        >
          <img src={BritishFlag} alt={strings[language].settingsPage.en} />
          <h2>{strings[language].settingsPage.en}</h2>
        </div>
        <div
          className={`${styles.item} ${language !== "de" ? {} : styles.active}`}
          onClick={() => flagClicked("de")}
        >
          <img src={GermanFlag} alt={strings[language].settingsPage.de} />
          <h2>{strings[language].settingsPage.de}</h2>
        </div>
      </div>
      <Link to="/">
        <FloatingButton
          icon={<FcUndo size={30} className="floating-button-icon" />}
          style={{ top: "10px", left: "10px" }}
        />
      </Link>
    </div>
  );
};

export default SettingsPage;
